module.exports = __webpack_public_path__ + "assets/img/bu_logo.0a3c63e8.png";